import React, { useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { CloseIcon } from "@icarius-icons";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  DialogActions,
  Typography,
  TextField,
  InputAdornment,
} from "@material-ui/core";
import { SearchIcon } from "@icarius-icons";
import { getLocalizedString } from "@icarius-localization/strings";
import DialogTitleDivider from "@icarius-common/dialogTitleDivider";
import PaperDraggable from "@icarius-common/paperDraggable";
import ButtonDialogAction from "@icarius-common/buttonDialogAction";
import DialogTransition from "@icarius-common/dialogTransition";
import { openSnackbarAction } from "@icarius-common/snackbar/actions";
import Counter from "@icarius-common/counter";
import Items from "./items";
import useHandleSelection from "./useHandleSelection";

const SelectionDialog = (props) => {

  const {
    open,
    required,
    items, // array de objetos con key, value
    disabledItems, // array de key de items a desactivar
    initialData, // array de keys
    title,
    selectedTitle,
    filterPlaceholder,
    helperText,
    getItemSubtitle, // funcion que devuelve string que se muestra abajo del nombre del item, si no se pasa la funcion, no se muestra nada
    getItemAvatar, // funcion que devuelve string con el final del path de la imagen (sin el IMAGE_ENDPOINT), si no se pasa la funcion, no se muestra nada
    singleSelection,
    handleSubmit,
    handleClose,
  } = props;

  const [searchValue, setSearchValue] = useState("");

  const dispatch = useDispatch();

  const {
    selectedKeys,
    handleSelection,
  } = useHandleSelection(initialData, singleSelection);

  const submit = () => {
    if (required && !selectedKeys.length) {
      dispatch(openSnackbarAction({ msg: getLocalizedString("invalidData"), severity: 'error' }));
      return;
    }

    handleSubmit(selectedKeys);
    handleClose();
  }

  const selectedItems = useMemo(() => {
    return items.filter((item) => selectedKeys.includes(item.key))
  }, [items, selectedKeys])

  const filteredItems = useMemo(() => {
    if (!searchValue) return items;

    return items.filter((item) => item.value.toLowerCase().includes(searchValue.toLowerCase()));
  }, [items, searchValue])

  return (
    <Dialog
      open={open}
      TransitionComponent={DialogTransition}
      PaperComponent={PaperDraggable}
      maxWidth={"lg"}
      fullWidth
    >
      <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
        {title}
        <DialogTitleDivider />
      </DialogTitle>
      <CloseIcon className={"dialog-close-icon icon"} onClick={handleClose} />
      <DialogContent>
        <Grid container direction="row" spacing={2}>
          <Grid container direction="row" item xs={12} md={6}>
            <Grid item xs={12} style={{ paddingBottom: 20 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 20, height: 32 }}>
                <Typography variant="h6" className="whiteText" style={{ fontWeight: 600, fontSize: 18 }}>
                  {selectedTitle}
                  {
                    required &&
                    <span style={{ fontWeight: 400, fontSize: 16, marginLeft: 5 }} className="errorColor" variant="caption">
                      {"*"}
                    </span>
                  }
                </Typography>
                <Counter
                  value={selectedItems.length}
                />
              </div>
            </Grid>
            <Grid item xs={12}>
              <Items
                items={selectedItems}
                disabledItems={disabledItems}
                selectedKeys={selectedKeys}
                getItemSubtitle={getItemSubtitle}
                getItemAvatar={getItemAvatar}
                handleClick={handleSelection}
                isSelection={false}
              />
            </Grid>
          </Grid>
          <Grid container direction="row" item xs={12} md={6}>
            <Grid item xs={12} style={{ paddingBottom: 20 }}>
              <div style={{ display: "flex", alignItems: "center", height: 32 }}>
                <TextField
                  value={searchValue}
                  onChange={(e) => setSearchValue(e.target.value)}
                  placeholder={filterPlaceholder || getLocalizedString("search")}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                    ),
                  }}
                  fullWidth
                />
              </div>
            </Grid>
            <Grid item xs={12}>
              <Items
                items={filteredItems}
                disabledItems={disabledItems}
                selectedKeys={selectedKeys}
                getItemSubtitle={getItemSubtitle}
                getItemAvatar={getItemAvatar}
                handleClick={handleSelection}
                isSelection={true}
              />
            </Grid>
          </Grid>
        </Grid>
        {
          helperText &&
          <Typography className="whiteText" align="center" style={{ padding: 10 }}>
            {helperText}
          </Typography>
        }
      </DialogContent>
      <DialogActions>
        <ButtonDialogAction onClick={handleClose} text={getLocalizedString("disagree")} />
        <ButtonDialogAction onClick={submit} isAccept text={getLocalizedString("save")} />
      </DialogActions>
    </Dialog>
  );
}

export default SelectionDialog;